<modal-header title="BrewBill Marker"></modal-header>

<ion-content class="ion-text-center">
    <button *ngFor="let i of markers" class="marker" (click)="submit(i)" [disabled]="active.indexOf(i) > -1">{{ i }}</button>
    <button class="marker-none" (click)="submit('none')">None</button>
</ion-content>

<modal-footer [hideSubmit]="true"></modal-footer>
